import React, { useState, useEffect } from 'react';
import { languageManager } from '../utils/i18n';

const LanguageSwitcher = () => {
	const [currentLang, setCurrentLang] = useState(languageManager.getCurrentLanguage());

	useEffect(() => {
		setCurrentLang(languageManager.getCurrentLanguage());
	}, []);

	const toggleLanguage = () => {
		const newLang = currentLang === 'uk' ? 'en' : 'uk';
		if (languageManager.setLanguage(newLang)) {
			setCurrentLang(newLang);
			window.dispatchEvent(new Event('languageChanged'));
		}
	};

	return (
		<div className="language-switcher footer__menu-item">
			<button
				className="lang-button"
				onClick={toggleLanguage}
				aria-label={languageManager.t('language')}
			>
				{currentLang === 'uk' ? 'EN' : 'UA'}
			</button>
		</div>
	);
};

export default LanguageSwitcher;

// Додаємо стилі для перемикача мови
const styles = `
  .language-switcher {
    display: inline-block;
  }
  
  .lang-button {
    font-family: var(--font-regular);
    background: none;
    padding: 4px 8px;
    cursor: pointer;
    border: none;
    transition: all 0.3s ease;
    height: 100%;
    width: 100%;
    font-size: 16px;
  }
`;

// Додаємо стилі до документа
if (typeof document !== 'undefined') {
	const styleElement = document.createElement('style');
	styleElement.textContent = styles;
	document.head.appendChild(styleElement);
}